module.exports = __webpack_public_path__ + "img/21_89.bdbd6ff6.png";